import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import heroLady from '../assets/hero-lady.png';
import products from '../assets/products.jpeg';
import './Home.css';

const PHONE = '+91-8796769013';
const WHATSAPP = '+918796769013';
const WA_MSG = encodeURIComponent('नमस्ते! मुझे महिला स्वास्थ्य से संबंधित परामर्श चाहिए।');

const API = 'http://localhost:5000/api'

const STATIC_TESTIMONIALS = [
  { id: 1, name: 'प्रिया शर्मा', location: 'दिल्ली', review: 'Shristiveda के मार्गदर्शन से मुझे काफी आराम महसूस हुआ। 2 महीने में ही बहुत फर्क आया। बहुत धन्यवाद!', rating: 5 },
  { id: 2, name: 'अनीता देवी', location: 'लखनऊ', review: 'बहुत अच्छी सेवा और गोपनीय परामर्श मिला। घर बैठे ही सारी जानकारी मिल गई। मैं बहुत खुश हूं।', rating: 5 },
  { id: 3, name: 'सुमन गुप्ता', location: 'जयपुर', review: 'पहले बहुत घबराहट थी लेकिन यहां बात करके मन शांत हो गया। आयुर्वेदिक उपाय बहुत कारगर रहे।', rating: 5 },
  { id: 4, name: 'रेखा वर्मा', location: 'वाराणसी', review: 'सेवा और मार्गदर्शन दोनों बेहतरीन हैं। टीम बहुत समझदार और सहायक है। जरूर संपर्क करें।', rating: 5 },
];

export default function Home() {
  const [testimonials, setTestimonials] = useState(STATIC_TESTIMONIALS);
  const [blogs, setBlogs] = useState([]);
  const [openFaq, setOpenFaq] = useState(null);
  const [enquiryForm, setEnquiryForm] = useState({ name: '', phone: '', message: '' });
  const [formStatus, setFormStatus] = useState('');
  const sectionsRef = useRef([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`)
      .then(r => { if (r.data && r.data.length > 0) setTestimonials(r.data); })
      .catch(() => {}); // fallback to STATIC_TESTIMONIALS on error
    axios.get(`${API}/blogs`).then(r => setBlogs(r.data.slice(0, 3))).catch(() => {});
  }, []);

  // Intersection observer for animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleEnquiry = async (e) => {
    e.preventDefault();
    if (!enquiryForm.name || !enquiryForm.phone) { setFormStatus('error'); return; }
    try {
      await axios.post(`${API}/enquiries`, {
      name: enquiryForm.name.trim(),
      phone: enquiryForm.phone.trim(),
      message: enquiryForm.message.trim(),
      source: 'website',
      });
      setFormStatus('success');
      setEnquiryForm({ name: '', phone: '', message: '' });
    } catch { setFormStatus('error'); }
  };

  const faqs = [
    {
      q: 'क्या सफेद पानी सामान्य है?',
      a: 'थोड़ी मात्रा में साफ या हल्का सफेद स्राव सामान्य है और यह शरीर की सफाई प्रक्रिया का हिस्सा है। लेकिन अगर मात्रा अधिक हो, दुर्गंध आए, रंग पीला/हरा/भूरा हो, या खुजली-जलन हो, तो यह किसी समस्या का संकेत हो सकता है।'
    },
    {
      q: 'कब डॉक्टर से संपर्क करना चाहिए?',
      a: 'यदि स्राव की मात्रा अचानक बढ़ जाए, असामान्य रंग या गंध हो, पेट में दर्द हो, बुखार हो, या लगातार खुजली-जलन हो तो तुरंत चिकित्सक से मिलें। साथ ही यदि सामान्य उपायों से 2-3 हफ्ते में कोई सुधार न हो तो भी परामर्श लें।'
    },
    {
      q: 'क्या घर बैठे सलाह मिल सकती है?',
      a: 'हां, हम WhatsApp और Phone के माध्यम से घर बैठे पूरी तरह गोपनीय परामर्श प्रदान करते हैं। आपकी जानकारी पूरी तरह सुरक्षित रहती है। हमारी टीम से संपर्क करें और अपनी समस्या बताएं।'
    },
    {
      q: 'क्या आयुर्वेदिक उत्पादों का कोई साइड इफेक्ट है?',
      a: 'हमारे सभी उत्पाद 100% प्राकृतिक आयुर्वेदिक सामग्री से बने हैं और इनमें कोई हानिकारक रसायन नहीं है। सही मात्रा और विधि से लेने पर इनका कोई दुष्प्रभाव नहीं होता। फिर भी गर्भावस्था या किसी अन्य बीमारी में पहले चिकित्सक से सलाह अवश्य लें।'
    },
    {
      q: 'कितने समय में परिणाम दिखेगा?',
      a: 'आमतौर पर नियमित सेवन से 4-8 सप्ताह में सकारात्मक बदलाव महसूस होने लगता है। परिणाम व्यक्ति की स्थिति, समस्या की गंभीरता और जीवनशैली पर निर्भर करते हैं। स्वस्थ आहार और नियमित दिनचर्या से परिणाम तेज़ आते हैं।'
    },
  ];

  const symptoms = [
    'बार-बार सफेद पानी आना',
    'कमर दर्द और भारीपन',
    'कमजोरी और थकान',
    'चिड़चिड़ापन और मूड स्विंग',
    'पैरों और जोड़ों में दर्द',
    'शरीर में भारीपन और आलस',
    'इंफेक्शन और खुजली',
    'ध्यान केंद्रित करने में कठिनाई',
  ];

  const reasons = [
    { icon: '⚖️', title: 'हार्मोनल बदलाव', desc: 'शरीर में एस्ट्रोजन और प्रोजेस्टेरोन का असंतुलन' },
    { icon: '🦠', title: 'बैक्टीरियल संक्रमण', desc: 'बैक्टीरिया या फंगल इंफेक्शन से योनि की प्राकृतिक अम्लता बदलती है' },
    { icon: '💪', title: 'कमजोर इम्युनिटी', desc: 'कमजोर प्रतिरक्षा प्रणाली से बार-बार संक्रमण होता है' },
    { icon: '🍽️', title: 'असंतुलित आहार', desc: 'पोषण की कमी और अनियमित खानपान से शरीर कमजोर होता है' },
  ];

  const products_list = [
    { name: 'Pushyanug Churna', benefit: 'सफेद पानी में राहत, गर्भाशय को मजबूती' },
    { name: 'Supari Pak', benefit: 'प्रजनन स्वास्थ्य, शारीरिक शक्ति बढ़ाए' },
    { name: 'Chandraprabha Vati', benefit: 'UTI में मदद, हार्मोनल संतुलन' },
    { name: 'Ayurvedic Syrup', benefit: 'इम्युनिटी बूस्ट, समग्र स्वास्थ्य' },
  ];

  const whyUs = [
    { icon: '🌿', title: 'अनुभवी आयुर्वेदिक टीम', desc: 'वर्षों के अनुभव के साथ महिला स्वास्थ्य में विशेषज्ञता' },
    { icon: '🏠', title: 'घर बैठे मार्गदर्शन', desc: 'बिना कहीं जाए, घर की सुविधा में परामर्श पाएं' },
    { icon: '🔒', title: 'गोपनीय परामर्श', desc: 'आपकी हर जानकारी 100% सुरक्षित और गोपनीय' },
    { icon: '💊', title: 'कोई साइड इफेक्ट नहीं', desc: '100% प्राकृतिक आयुर्वेदिक सामग्री, पूरी तरह सुरक्षित' },
    { icon: '📱', title: 'आसान प्रक्रिया', desc: 'WhatsApp पर मैसेज करें, तुरंत जवाब पाएं' },
    { icon: '✅', title: 'प्रमाणित उत्पाद', desc: 'आयुर्वेदिक प्रोप्राइटरी मेडिसिन, गुणवत्ता में कोई समझौता नहीं' },
  ];

  return (
    <div className="home">
      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero-bg-pattern" />
        <div className="container hero-inner">
          <div className="hero-content">
            <div className="hero-badge reveal">
              <span className="pulse-dot" />
              महिलाओं के लिए विशेष आयुर्वेदिक समाधान
            </div>
            <h1 className="hero-title reveal">
              बार-बार <span className="highlight">सफेद पानी,</span><br />
              कमर दर्द और कमजोरी<br />
              से परेशान?
            </h1>
            <p className="hero-subtitle reveal">
              महिलाओं के लिए आयुर्वेदिक मार्गदर्शन — घर बैठे, गोपनीय और सुरक्षित
            </p>
            <div className="hero-checks reveal">
              {['महिलाओं की समस्याओं पर विशेष ध्यान', 'घर बैठे परामर्श', 'आयुर्वेद आधारित देखभाल'].map(c => (
                <div className="check-item" key={c}>
                  <span className="check-icon">✓</span>
                  <span>{c}</span>
                </div>
              ))}
            </div>
            <div className="hero-btns reveal">
              <a href={`tel:${PHONE}`} className="btn-primary">
                📞 अभी Call करें
              </a>
              <a href={`https://wa.me/${WHATSAPP}?text=${WA_MSG}`} target="_blank" rel="noreferrer" className="btn-whatsapp">
                💬 WhatsApp करें
              </a>
            </div>
            <div className="hero-stats reveal">
              <div className="stat">
  <strong>100%</strong>
  <span>आयुर्वेदिक</span>
</div>

<div className="stat-divider" />

<div className="stat">
  <strong>Natural</strong>
  <span>हर्बल फॉर्मूलेशन</span>
</div>

<div className="stat-divider" />

<div className="stat">
  <strong>Safe</strong>
  <span>महिला स्वास्थ्य हेतु</span>
</div>
            </div>
          </div>
          <div className="hero-image reveal">
            <div className="hero-img-wrapper">
              <img src={heroLady} alt="महिला स्वास्थ्य" />
              <div className="hero-img-badge">
                <span>🌿</span>
                <div>
                  <strong>100% Natural</strong>
                  <small>& Safe</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-wave">
          <svg viewBox="0 0 1440 60" preserveAspectRatio="none">
            <path d="M0,30 C360,60 1080,0 1440,30 L1440,60 L0,60 Z" fill="#fdf8f0"/>
          </svg>
        </div>
      </section>

      {/* ── SYMPTOMS ── */}
      <section className="symptoms-section">
        <div className="container">
          <div className="section-header reveal" style={{ textAlign: 'center', marginBottom: '48px' }}>
            <span className="section-label">लक्षण</span>
            <h2 className="section-title">क्या आपको इनमें से कोई समस्या है?</h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>
              अगर इनमें से कोई भी लक्षण आपको है, तो देरी न करें — आज ही विशेषज्ञ से बात करें
            </p>
          </div>
          <div className="symptoms-grid">
            {symptoms.map((s, i) => (
              <div className="symptom-card reveal" key={s} style={{ animationDelay: `${i * 0.07}s` }}>
                <div className="symptom-icon">✓</div>
                <span>{s}</span>
              </div>
            ))}
          </div>
          <div className="symptoms-cta reveal">
            <a href={`https://wa.me/${WHATSAPP}?text=${WA_MSG}`} target="_blank" rel="noreferrer" className="btn-whatsapp">
              💬 मुफ्त परामर्श पाएं
            </a>
          </div>
        </div>
      </section>

      {/* ── WHY THIS HAPPENS ── */}
      <section className="reasons-section">
        <div className="container">
          <div className="section-header reveal" style={{ textAlign: 'center', marginBottom: '48px' }}>
            <span className="section-label">कारण</span>
            <h2 className="section-title">सफेद पानी की समस्या क्यों होती है?</h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>
              सही कारण जानकर सही समाधान पाएं
            </p>
          </div>
          <div className="reasons-grid">
            {reasons.map((r, i) => (
              <div className="reason-card reveal" key={r.title} style={{ animationDelay: `${i * 0.1}s` }}>
                <div className="reason-icon">{r.icon}</div>
                <h3>{r.title}</h3>
                <p>{r.desc}</p>
              </div>
            ))}
          </div>
          <div className="disclaimer-box reveal">
            <span>⚠️</span>
            <p><strong>Disclaimer:</strong> सही कारण जानने के लिए किसी योग्य आयुर्वेदिक या चिकित्सक से व्यक्तिगत सलाह लें।</p>
          </div>
        </div>
      </section>

      {/* ── PRODUCTS ── */}
      <section className="products-section">
        <div className="container">
          <div className="products-inner">
            <div className="products-text">
              <span className="section-label">आयुर्वेदिक सहायता</span>
              <h2 className="section-title">महिला स्वास्थ्य के लिए पारंपरिक आयुर्वेदिक घटक</h2>
              <p className="section-subtitle">
                सदियों से प्रयोग में आने वाले शुद्ध आयुर्वेदिक घटकों से निर्मित उत्पाद
              </p>
              <div className="products-list">
                {products_list.map((p, i) => (
                  <div className="product-item reveal" key={p.name} style={{ animationDelay: `${i * 0.1}s` }}>
                    <div className="product-badge">
                      <span className="product-num">{String(i + 1).padStart(2, '0')}</span>
                    </div>
                    <div>
                      <strong>{p.name}</strong>
                      <p>{p.benefit}</p>
                    </div>
                  </div>
                ))}
              </div>
              <a href={`https://wa.me/${WHATSAPP}?text=${WA_MSG}`} target="_blank" rel="noreferrer" className="btn-whatsapp reveal">
                💬 उत्पाद के बारे में जानें
              </a>
            </div>
            <div className="products-image reveal">
              <img src={products} alt="Shristiveda Products" />
              <div className="products-img-tag">
                <span>✓ Ayurvedic Proprietary Medicine</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── WHY CHOOSE US ── */}
      <section className="why-section">
        <div className="container">
          <div className="section-header reveal" style={{ textAlign: 'center', marginBottom: '48px' }}>
            <span className="section-label">हमारी विशेषता</span>
            <h2 className="section-title">हमें क्यों चुनें?</h2>
          </div>
          <div className="why-grid">
            {whyUs.map((w, i) => (
              <div className="why-card reveal" key={w.title} style={{ animationDelay: `${i * 0.08}s` }}>
                <div className="why-icon">{w.icon}</div>
                <h3>{w.title}</h3>
                <p>{w.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section className="testimonials-section">
        <div className="container">
          <div className="section-header reveal" style={{ textAlign: 'center', marginBottom: '48px' }}>
            <span className="section-label">ग्राहकों के अनुभव</span>
            <h2 className="section-title">उन्होंने क्या कहा?</h2>
          </div>
          <div className="testimonials-grid">
            {testimonials.map((t, i) => (
              <div className="testimonial-card reveal" key={t.id} style={{ animationDelay: `${i * 0.1}s` }}>
                <div className="stars">{'⭐'.repeat(t.rating || 5)}</div>
                <blockquote>"{t.review}"</blockquote>
                <div className="testimonial-author">
                  <div className="author-avatar">{t.name[0]}</div>
                  <div>
                    <strong>{t.name}</strong>
                    {t.location && <small>{t.location}</small>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── BLOGS PREVIEW ── */}
      {blogs.length > 0 && (
        <section className="blogs-preview-section">
          <div className="container">
            <div className="section-header reveal" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: '16px', marginBottom: '40px' }}>
              <div>
                <span className="section-label">ब्लॉग</span>
                <h2 className="section-title">स्वास्थ्य जानकारी</h2>
              </div>
              <Link to="/blogs" className="btn-navy">सभी ब्लॉग देखें →</Link>
            </div>
            <div className="blogs-grid">
              {blogs.map((b, i) => (
                <Link to={`/blogs/${b.slug}`} className="blog-preview-card reveal" key={b.id} style={{ animationDelay: `${i * 0.1}s` }}>
                  {b.image_url && (
                    <div className="blog-img">
                      <img src={`http://localhost:5000${b.image_url}`} alt={b.title} />
                    </div>
                  )}
                  <div className="blog-preview-body">
                    <span className="blog-category">{b.category}</span>
                    <h3>{b.title}</h3>
                    <p>{b.excerpt}</p>
                    <span className="blog-read-more">पढ़ें →</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ── FAQ ── */}
      <section className="faq-section">
        <div className="container">
          <div className="section-header reveal" style={{ textAlign: 'center', marginBottom: '48px' }}>
            <span className="section-label">FAQ</span>
            <h2 className="section-title">अक्सर पूछे जाने वाले प्रश्न</h2>
          </div>
          <div className="faq-list">
            {faqs.map((f, i) => (
              <div className={`faq-item reveal ${openFaq === i ? 'open' : ''}`} key={i} onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                <div className="faq-question">
                  <span>{f.q}</span>
                  <span className="faq-arrow">{openFaq === i ? '▲' : '▼'}</span>
                </div>
                {openFaq === i && <div className="faq-answer">{f.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ENQUIRY FORM ── */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-inner">
            <div className="contact-info reveal">
              <span className="section-label">संपर्क करें</span>
              <h2 className="section-title" style={{ color: 'white' }}>
                सफेद पानी की समस्या को नजरअंदाज न करें
              </h2>
              <p style={{ color: 'rgba(255,255,255,0.75)', marginBottom: '28px' }}>
                अभी विशेषज्ञ से बात करें — पूरी तरह गोपनीय और निःशुल्क परामर्श
              </p>
              <div className="contact-methods">
                <a href={`tel:${PHONE}`} className="contact-method-btn">
                  📞 {PHONE}
                </a>
                <a href={`https://wa.me/${WHATSAPP}?text=${WA_MSG}`} target="_blank" rel="noreferrer" className="contact-method-btn whatsapp">
                  💬 WhatsApp पर बात करें
                </a>
              </div>
            </div>
            <div className="contact-form-box reveal">
              <h3>अपना विवरण भेजें</h3>
              <p>हम जल्द ही आपसे संपर्क करेंगे</p>
              <form onSubmit={handleEnquiry}>
                <div className="form-group">
                  <label>नाम *</label>
                  <input
                    type="text" placeholder="आपका नाम"
                    value={enquiryForm.name}
                    onChange={e => setEnquiryForm({ ...enquiryForm, name: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>फ़ोन नंबर *</label>
                  <input
                    type="tel" placeholder="+91 XXXXX XXXXX"
                    value={enquiryForm.phone}
                    onChange={e => setEnquiryForm({ ...enquiryForm, phone: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>संदेश</label>
                  <textarea
                    placeholder="अपनी समस्या संक्षेप में बताएं..."
                    rows={3}
                    value={enquiryForm.message}
                    onChange={e => setEnquiryForm({ ...enquiryForm, message: e.target.value })}
                  />
                </div>
                {formStatus === 'success' && <p className="form-success">✅ आपका संदेश भेज दिया गया! हम जल्द संपर्क करेंगे।</p>}
                {formStatus === 'error' && <p className="form-error">❌ कुछ गलत हुआ, दोबारा कोशिश करें।</p>}
                <button type="submit" className="btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
                  संदेश भेजें →
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
